import {useEffect, useState} from 'react';

import {Add, Remove} from '@mui/icons-material';
import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

import usePayment from '../../../../../hooks/providers/usePayment';
import {productShape} from '../../../../../proptypes-shapes';
import HoldButton from '../HoldButton/HoldButton';
import ProductCardQuantityInput from '../ProductCardQuantityInput/ProductCardQuantityInput';

const ProductQuantitySelector = ({product}) => {
  const [rawQuantity, setRawQuantity] = useState(undefined);

  const {getCartProduct, setCartProductQuantity, subscription} = usePayment();
  const cartProduct = getCartProduct(product.id);
  const productQuantity = cartProduct?.quantity || 0;
  const displayedQuantity = rawQuantity !== undefined ? Number(rawQuantity) || 0 : productQuantity;

  const allProducts = subscription?.products || [];
  const quantityFieldErrorText = allProducts.find(p => p.product_id === product.id)?.quantity_field_error_text;

  useEffect(() => {
    setRawQuantity(productQuantity);
  }, [productQuantity]);

  const handleProductQuantityChange = event => {
    setRawQuantity(event.target.value);
  };

  const isMinusButtonDisabled = productQuantity === 0 || productQuantity <= cartProduct?.minimum_quantity;

  const changeQuantity = delta => {
    setRawQuantity(currentRawQuantity => {
      if (currentRawQuantity + delta < cartProduct?.minimum_quantity) return currentRawQuantity;
      return (currentRawQuantity ?? productQuantity) + delta;
    });
  };

  const commitQuantity = () => {
    const final = Math.max(rawQuantity, cartProduct?.minimum_quantity ?? 0);
    setCartProductQuantity(product, final);
    setRawQuantity(final);
  };

  const handleQuantityBlur = () => {
    const parsed = parseInt(rawQuantity, 10);

    if (Number.isNaN(parsed)) {
      const fallback = cartProduct?.minimum_quantity || 0;
      setRawQuantity(fallback);
      return;
    }

    const clamped = Math.max(parsed, cartProduct?.minimum_quantity || 0);
    setCartProductQuantity(product, clamped);
    setRawQuantity(clamped);
  };

  return (
    <Grid
      item
      xs={6}
      sm={8}
      lg={3.5}
      pl={{
        xs: 0,
        lg: 4
      }}
      mt={{
        xs: 2,
        sm: 0
      }}
    >
      <Typography fontSize={12} mb={1.5} color="text.secondary">
        {product.quantity_field_label}
      </Typography>

      <Grid container flexWrap="nowrap" alignItems="center">
        <HoldButton onStop={commitQuantity} delta={-1} onChange={changeQuantity} disabled={isMinusButtonDisabled} tooltip={isMinusButtonDisabled && productQuantity > 0 ? quantityFieldErrorText : ''}>
          <Remove fontSize="small" />
        </HoldButton>

        <ProductCardQuantityInput id={product.id} quantity={displayedQuantity} handleBlur={handleQuantityBlur} handleChange={handleProductQuantityChange} />

        <HoldButton onStop={commitQuantity} delta={1} onChange={changeQuantity}>
          <Add fontSize="small" />
        </HoldButton>
      </Grid>
    </Grid>
  );
};

ProductQuantitySelector.propTypes = {
  product: productShape.isRequired
};

export default ProductQuantitySelector;
